define('drops/barCode/barCode',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq'
], function ($, Drop, Style, util, lq) {
    'use strict';

    function Barcode(options) {
        Drop.call(this, $('<div />'), options);
        var self = this;
       
        self.$image = $('<img />')
            .attr('title', self.data.title)
            .on('load', function () {
                self.$image.show();
            })
            .hide()
            .appendTo(self.$element);

        self.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });

        Style.renderStyles(self);

        self.setValue(null);
        return self;
    };

    Drop.extend(Barcode, Drop);

    Barcode.typeName = 'Barcode';

    Barcode.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };
    
    Barcode.prototype.clearValue = function () {
        this.$image.attr('src', '');
    };

    Barcode.prototype.rgba2hex = function (rgba) {
        var rgb = rgba.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ?
          ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
          ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
          ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : 'FFFFFF';
    }

    Barcode.prototype.setValue = function (update) {
        var self = this;
        
        var value = (update === null) ? self.data.value : util.convertListOfKeyValuesToObject(update.value);
        if (!value) {
            self.$image.hide();
            return;
        }

        var filePath = lq.getTenantUrl("GeneratedContent/Barcode/"
                                            + "?code=" + value
                                            + "&height=" + (self.data.size.y - self.data.styles.normal.padding.top - self.data.styles.normal.padding.bottom - (self.data.styles.normal.border.width * 2))
                                            + "&width=" + (self.data.size.x - self.data.styles.normal.padding.left - self.data.styles.normal.padding.right - (self.data.styles.normal.border.width*2))
                                            + "&type=" + self.data.selectedType
                                            + "&barcodeColor=" + self.rgba2hex(self.data.styles.normal.font.color)
                                            + "&backgroundColor=" + self.rgba2hex(self.data.styles.normal.background.color)
                                            + "&fontFamily=" + self.data.styles.normal.font.fontFamily.split(",")[0].replace(/'/g, "")
                                            + "&fontSize=" + self.data.styles.normal.font.size,
                                            + "&fontColor=" + self.rgba2hex(self.data.styles.normal.font.color)
                                            + "&hideLabel=" + self.data.hideLabel);

        self.$image
            .hide()
            .attr('src', filePath);

        if (self.$image[0].complete) {
            self.$image.trigger('load');
        }
    };

    return Barcode;
});
